
// VITE_BLOCKCHAIN_DATABASE_ID

import { databases } from "@/lib/appwrite"
import { ID, Query, type Models } from "appwrite"
import type { Instrument, InstrumentForm } from "./types"

// 
export const createInstrument = async (data: InstrumentForm): Promise<string> => {
    const doc = await databases.createDocument(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        ID.unique(),
        data
    )
    return doc.$id
}

export const getInstrument = async (): Promise<Models.DocumentList<Instrument>> => {
    const result = await databases.listDocuments<Instrument>(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        [Query.limit(500), Query.orderDesc("$createdAt")],
    )
    return result
}

export const deleteInstrument = async (idDocument: string) => {
    await databases.deleteDocument(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        idDocument
    )
}

export const updateInstrument = async (idDocument: string, data: Partial<InstrumentForm>) => {
    const result = await databases.updateDocument(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        idDocument,
        data
    )
    return result;
}


export const checkSerialExists = async (serialNumber: string): Promise<boolean> => {
    const result = await databases.listDocuments(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        [Query.equal("serialNumber", serialNumber.trim())]
    )
    return result.total > 0
}


export const getInstrumentById = async (id: string): Promise<Instrument> => {
    const result = await databases.getDocument<Instrument>(
        import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID,
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
        id
    )
    return result
}